import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconMenu = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="yfm-icon yfm-icon-menu"
    {...omit(props, ["className"])}
  >
    <rect width="32" height="32" fill="url(#pattern0_16320_582)" />
    <defs>
      <pattern
        id="pattern0_16320_582"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_16320_582" transform="scale(0.0188679)" />
      </pattern>
      <image
        id="image0_16320_582"
        width="53"
        height="53"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANaADAAQAAAABAAAANQAAAADneQ/wAAADAElEQVRoBe1aO68SQRSeXeRKRQEJhZJcIregtyIEKGm5uXJDD6WJ0ULQH2CMNjb+AgoKbny0/AZBYkhoNNEEcuk1RNYIfmeVlYCJ95zs8JgwyWFnZs/j++adZSz1jzSfz49QXZzNZkXLstLI34BQ3bbTNwAYAt9727ZfI/8W+JxVUNZqBQxOIc9Qf7L6bgfLH0GqBnm1jM0jBSIB9MwTKDxcVtiHPHUCeu4xsP8kvNcWoPeVEOGnjgB+ytbcMv2A6R1Ii/L7nECuBLmwQOYI8glk4vtM6A/2EUjdslEoGUKIeN2EnNvopSKVTEnEx8IE+wxCx6aQAo8vROo7MtcNIuUQqblBhFwqtFAYlw6k9qVLvWMSFzA2Oa6JSB9LNNtORIoIdTodVa1W2QE5BuVyWdVqNTrGccz+HmhZVlDu9/uq1+txzVj6oVDIJcUygrJ4oQgGg9xYbP1AIMC2IQPR8CPDbDar6vU6ZbWlfD4v8i3efI1bKKj5uJNX1ORCI/GcEsbbiJl4Thk5/MbjsWo0GlpbPp1Oq0wmw49Bp3SuYD7Nm80m7YhaJZfLUSg2PvGcmk6n/BZkWjjO2nfKK3kQz6lUKqWSyeSVgkiVCoWCyNTIfUo8/DDURa24CSPx8CNwu0pMTMrIfYpWpuFwqHU0RaNRFQ6H+TG4exTpU2q321r3KBrdlUrFjcXFKF4oRqMRvwWZFoPBgGnxW11MKhKJiAJyjGKxGEfd0xXvU5PJRHW7Xc+RjkwikVDxOP/PGDEpI1c/zGAdneOLT/Gc8iW6JicHUpoa1ne3h57yvUk1OaSe+qrJ97bcOkTqclvRNcW9JFIfNDnfltt3Nk4Gb7YVXUdc4mPijZck9ZQDeaCj1TbtEzzuQ6buPoVMC2e555sG4Wc8wk88yKf3xy0q6b7fC7y462ewTfgC9pe473cP2N37fh6pRXAonEGeonyyqNvhJ93MfAS5WMa4RopeghTdly3heYrnbQjdztL/fyiC/Cf9wHv6jtABEbpD28Jz7dv0LzqT/IdsK7cyAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
));

IconMenu.displayName = "IconMenu";

export default IconMenu;
